import { getDataForChart } from '../../../utils/reactChartConfig'
import { CONSTRUCTS } from '../../../utils/constructs'
import { convert1to6ToPercent } from '../../../utils/statisticCalc'

/**
 * called by ResultsModule5.js
 * @param jtLabels, object, 'label' portion of the jsonText object from Redux
 * @param modNpoAnswers, object, latest NPO survey answers for current module
 * @param benchMod, object, benchmark of either this NPO category or of all NPOs
 * @param modResults, object, the latest results of the user's organization with respect to above benchmark (percentiles)
 * @param benchType, string, benchmark chartType, either 'cat' or 'all'
 * @param yearlyComp, object, containing all the info and data for a yearly comparison (or null)
 * @param chartType, string, either 'summary' (overall result) or the section name (not yet used)
 * @return object, the chart data for Module 5
 *
 * Note: for yearly comparison, we use the following variables slightly differently:
 * modNpoAnswers = benchmark, either for all NPOs ('all') or only the NPOs of the same category ('cat')
 * benchMod = last survey results
 * modResults = results of selected year's survey (or null)
 * benchType = always null
 */
export const getChartDataMod5 = (jtLabels, modNpoAnswers, benchMod, modResults, benchType, yearlyComp, chartType) => {
  if (yearlyComp) {
    modNpoAnswers = yearlyComp.benchmark
    benchMod = yearlyComp.lastSurveyResults
    modResults = yearlyComp.selectedSurveyResults
    benchType = null
  }
  let chartLabels, npoData, benchData, resultsData
  switch (chartType) {
    case 'summary':
      chartLabels = [  // the order here pertains only to the chart
        `${jtLabels[CONSTRUCTS.SOCIAL_MISSION.name] || 'Social Mission'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.MOBILIZATION.name] || 'Mobilization'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.GROWTH.name] || 'Growth'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.PROFITABILITY.name] || 'Profitabilty'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.PERSONNEL_CHANGE.name] || 'Personnel Change'}`.toUpperCase(),
      ]
      npoData = [
        modNpoAnswers?.SAZ.mean,
        modNpoAnswers?.MOB.mean,
        modNpoAnswers?.WAC.mean,
        modNpoAnswers?.PRF.mean,
        modNpoAnswers?.MIT.mean,
      ]
      benchData = [
        benchMod?.SAZ.mean,
        benchMod?.MOB.mean,
        benchMod?.WAC.mean,
        benchMod?.PRF.mean,
        benchMod?.MIT.mean,
      ]
      if (yearlyComp) resultsData = [
        modResults?.SAZ.percentile,
        modResults?.MOB.percentile,
        modResults?.WAC.percentile,
        modResults?.PRF.percentile,
        modResults?.MIT.percentile,
      ]
      break
    default:
      console.error('No match found for chart chartType:', chartType)
  }

  return getDataForChart(jtLabels, chartLabels, npoData, benchData, resultsData, benchType, yearlyComp)
}
